module.exports = {
  "view.类型": "Tipe",
  "view.询价": "cek harga",
  "view.招标": "penawaran",
  "view.预计金额": "Perkiraan jumlah",
  "view.竞标保证金": "Setoran penawaran",
  "view.招标单位": "satuan tender",
  "view.正文内容": "isi teks",
  "view.截止时间": "Tenggat waktu",
  "view.没有找到相关项目": "Tidak ada item terkait yang ditemukan",
  "view.欢迎登录信翼通招标网": "Selamat datang di Jaringan Penawaran Xinyitong",
  "view.请输入账号/手机号": "Silakan masukkan nomor akun/ponsel Anda",
  "view.请输入密码": "Silakan masukkan kata sandi",
  "view.立即登录": "Masuk sekarang",
  "view.忘记密码": "lupa kata sandi",
  "view.还没账号？": "Belum ada akun",
  "view.立即注册": "Daftar sekarang",
  "view.请输入": "silahkan tekan",
  "view.记住密码": "Ingat kata sandi",
  "view.您好，欢迎来到信翼通招标网！": "Halo, selamat datang di Jaringan Penawaran Xinyitong",
  "view.登录": "masuk",
  "view.注册": "Terdaftar",
  "view.退出": "Mengundurkan diri",
  "view.认证信息已上传，目前正在审核中，请耐心等待": "Informasi sertifikasi telah diunggah dan sedang ditinjau. Harap menunggu dengan sabar.",
  "view.已认证": "bersertifikat",
  "view.工作台": "platform kerja",
  "view.信翼通招标网": "Jaringan Penawaran Xinyitong",
  "view.搜索": "pencarian",
  "view.首页": "halaman depan",
  "view.物资项目": "Barang-barang material",
  "view.工程项目": "Proyek rekayasa",
  "view.服务项目": "Layanan",
  "view.企业认证": "Sertifikasi Bisnis",
  "view.营业执照": "izin usaha (NIB)",
  "view.营业执照有效期": "Masa berlaku izin usaha",
  "view.期限类型": "Jenis masa berlaku",
  "view.长期": "Jangka panjang",
  "view.固定时间段": "Periode tetap",
  "view.请选择开始时间": "Silakan pilih waktu mulai",
  "view.请选择结束时间": "Silakan pilih waktu berakhir",
  "view.是否法人": "Apakah itu entitas hukum",
  "view.是": "iya",
  "view.否": "tidak",
  "view.身份证(正面)": "Kartu Identitas (bagian depan)",
  "view.身份证(反面)": "Kartu Identitas (bagian belakang)",
  "view.投标授权委托书": "Surat kuasa untuk penawaran",
  "view.重新上传": "Unggah ulang",
  "view.上传附件": "Tidak ada lampiran yang diunggah",
  "view.下载模版": "Unduh templat",
  "view.授权委托书有效时间": "Masa berlaku surat kuasa",
  "view.确 定": "konfirmasi",
  "view.取 消": "Membatalkan",
  "view.请上传营业执照": "Silakan unggah izin usaha Anda",
  "view.请选择营业执照有效期": "Silakan pilih masa berlaku izin usaha Anda",
  "view.请选择是否法人": "Silakan pilih apakah itu badan hukum",
  "view.请上传身份证(正面)": "Silahkan upload KTP anda (depan)",
  "view.请上传身份证(反面)": "Silakan unggah KTP (sisi belakang)",
  "view.请上传投标授权委托书": "Silakan unggah surat kuasa untuk melakukan penawaran",
  "view.请选择授权委托书有效时间": "Silahkan pilih masa berlaku surat kuasa",
  "view.格式有误": "Format salah",
  "view.最多上传3个文件": "ອັບໂຫລດໄດ້ສູງສຸດ 3 ໄຟລ໌",
  "view.投标授权委托书模板.docx": "Surat Kuasa Pelelangan.docx",
  "view.上传文件不能超过20MB": "File yang diunggah tidak boleh melebihi 20 MB",
  "view.上传文件不能为0KB": "File yang diupload tidak boleh 0KB",
  "view.上传成功": "Unggahan berhasil",
  "view.提交成功": "Pengajuan berhasil",
  "view.个人认证": "Otentikasi pribadi",
  "view.图片预览": "Pratinjau gambar",
  "view.去认证": "Pergi otentikasi",
  "view.请输入项目名称": "Please enter the project name",
  "view.APP下载": "Unduh APP",
  "view.信翼通招标系统App": "Aplikasi Sistem Tender",
  "view.(仅限安卓版本)": "(Hanya untuk versi Android saja)",
  "view.可使用微信扫一扫扫码下载": "Dapat menggunakan WeChat Scan untuk mendownload dengan memindai kode QR",
  "view.上传营业执照副本，仅用于资质审核": "Unggah salinan izin usaha Anda untuk peninjauan kualifikasi saja",
  "view.业绩": "Pertunjukan",
  "view.上传以往业绩合同附件，仅用于资质审核": "Unggah lampiran kontrak kinerja sebelumnya, hanya untuk tinjauan kualifikasi",
  "view.代理许可证": "Lisensi Agen",
  "view.提交": "kirim",
  "view.询价中": "Penyelidikan sedang berlangsung",
  "view.询价项目正在询价中，可以继续报价": "Item pertanyaan sedang dalam proses penyelidikan, Anda dapat melanjutkan mengutip",
  "view.已弃标": "Tawaran diabaikan",
  "view.询价结束": "Penyelidikan berakhir",
  "view.询价项目已结束，可以查看报价记录": "Proyek penyelidikan telah berakhir, Anda dapat melihat catatan kutipan",
  "view.基本信息": "Informasi dasar",
  "view.招标公告": "Pemberitahuan Tender",
  "view.标的物信息": "Informasi materi pelajaran",
  "view.序号": "nomor seri",
  "view.物资分类": "Klasifikasi bahan",
  "view.物资名称": "nama materi",
  "view.规格": "Spesifikasi",
  "view.型号": "model",
  "view.需求数量": "Jumlah yang dibutuhkan",
  "view.计量单位": "satuan pengukuran",
  "view.其他": "Komentar",
  "view.附件": "lampiran",
  "view.标的物附件": "Lampiran materi pelajaran",
  "view.投标信息": "Informasi tawaran",
  "view.公司名称/姓名": "Nama/nama perusahaan",
  "view.纳税人识别号": "Nomor Pokok Wajib Pajak",
  "view.联系电话": "Nomor kontak",
  "view.联系人": "Kontak",
  "view.电子邮件地址": "alamat email",
  "view.基础文件提交": "Pengiriman file dasar",
  "view.未通过原因": "Alasan kegagalan",
  "view.技术要求文件": "Dokumen Persyaratan Teknis",
  "view.是否符合要求": "Apakah memenuhi persyaratan",
  "view.符合": "sesuai dengan",
  "view.不符合": "Tidak bertemu",
  "view.请对与技术要求文件不符处进行说明": "Tolong jelaskan perbedaannya dengan dokumen persyaratan teknis",
  "view.供应商技术文件": "Dokumentasi teknis pemasok",
  "view.供应商业绩文件": "Dokumen Kinerja Pemasok",
  "view.资质上传": "Unggahan kualifikasi",
  "view.投标主体": "Subjek yang penawaran",
  "view.投标保证金": "Setoran tawaran",
  "view.标书费": "Biaya tender",
  "view.已缴纳": "dibayar",
  "view.保证金": "Batas",
  "view.缴费日期": "Tanggal Pembayaran",
  "view.缴费凭证": "Voucher Pembayaran",
  "view.审核中": "Sedang ditinjau",
  "view.缴费未通过": "Pembayaran gagal",
  "view.待缴纳": "Harus dibayar",
  "view.倒计时": "Hitung mundur",
  "view.账号名称": "Nama akun",
  "view.对方账户": "Akun pihak lain",
  "view.开户行": "Bank pembuka rekening",
  "view.缴费结束时间": "Waktu berakhirnya pembayaran",
  "view.缴费方式": "Metode pembayaran",
  "view.对公转账": "Transfer bisnis",
  "view.招标文件": "Dokumen tender",
  "view.未提交": "Tidak terikat",
  "view.递交开始时间": "Waktu mulai pengiriman",
  "view.递交结束时间": "Waktu berakhirnya pengiriman",
  "view.已超时": "Waktu habis",
  "view.上传投标文件": "Unggah dokumen penawaran",
  "view.请点击按钮上传投标文件，可以在投标截止时问前，修改或撤回投标文件": "Silakan klik tombol untuk mengunggah dokumen penawaran. Anda dapat mengubah atau menarik dokumen penawaran sebelum batas waktu penawaran",
  "view.如果要重新上传投标文件，必须将上次上传的投标文件撤回才可重新上传": "Bila ingin mengunggah ulang dokumen penawaran, Anda harus mencabut dokumen penawaran yang terakhir diunggah sebelum mengunggah ulang",
  "view.请充分考虑到传送的时间和自身的网络情况，在投标截止时间前完成投标，逾时传这会被判断为逾期送达": "Mohon pertimbangkan sepenuhnya waktu transmisi dan kondisi jaringan Anda sendiri, dan selesaikan penawaran sebelum batas waktu penawaran. Keterlambatan penyerahan akan dianggap sebagai keterlambatan pengiriman",
  "view.文件名称": "Nama file",
  "view.投标单位": "Unit Tender",
  "view.投标负责人": "Orang yang Bertanggung Jawab atas penawaran",
  "view.上传日期": "Tanggal unggah",
  "view.投标文件状态": "Status dokumen tender",
  "view.操作": "beroperasi",
  "view.查看原因": "Lihat alasan",
  "view.下载": "unduh",
  "view.撤回投标文件": "Menarik dokumen penawaran",
  "view.已上传的投标文件撤销成功后，请及时重新上传投标文件。务必保证操作历史中最新的为上传成功的记录。": "Setelah dokumen penawaran yang diunggah berhasil ditarik, harap unggah kembali dokumen penawaran tepat waktu. Pastikan untuk memastikan bahwa riwayat operasi terbaru adalah catatan unggahan yang berhasil. ",
  "view.开标报价": "Kutipan pembuka tawaran",
  "view.报价入口": "Entri Kutipan",
  "view.该投标项目已正式开标。": "Proyek penawaran telah resmi dibuka. ",
  "view.该询价项目已开始报价": "Penawaran telah dimulai untuk item pertanyaan ini",
  "view.点击报价按钮，前去报价": "Klik tombol penawaran untuk menuju ke penawaran",
  "view.去报价": "Pergi ke kutipan",
  "view.报价记录": "Catatan Kutipan",
  "view.第": "ke",
  "view.轮报价": "kutipan bulat",
  "view.物料名称": "Nama bahan",
  "view.预算金额": "Jumlah anggaran",
  "view.币种": "Mata uang",
  "view.含税单价": "Harga satuan termasuk pajak",
  "view.税率": "tarif pajak",
  "view.物料总价": "Total harga bahan",
  "view.其他费用": "Biaya lainnya",
  "view.总价": "Total harga",
  "view.结算方式": "Metode Pembayaran",
  "view.报价说明": "Deskripsi kutipan",
  "view.单个体积": "Volume tunggal",
  "view.体积单位": "Satuan volume",
  "view.单个重量": "Berat tunggal",
  "view.重量单位": "Satuan berat",
  "view.排名": "Peringkat",
  "view.本轮最低价": "Harga terendah di putaran ini",
  "view.整体总价": "Total harga",
  "view.整体排名": "Peringkat keseluruhan",
  "view.项目公示": "Pengumuman proyek",
  "view.报价轮次": "Putaran kutipan",
  "view.轮": "roda",
  "view.报价": "Mengutip",
  "view.你方": "Sisimu",
  "view.所递交的": "Dikirim",
  "view.投标文件已被我方接受，被确定为中标人。": "Dokumen penawaran telah kami terima dan kami telah dipastikan sebagai pemenang lelang. ",
  "view.中标价": "Memenangkan Harga Penawaran",
  "view.小写": "huruf kecil",
  "view.请你方在接到本通知书后的30日内到": "Harap datang dalam waktu 30 hari setelah menerima pemberitahuan ini",
  "view.与我方签订": "Tanda tangan bersama kami",
  "view.合同协议书": "Perjanjian Kontrak",
  "view.退还保证金": "Setoran pengembalian",
  "view.待退还保证金": "Setoran harus dikembalikan",
  "view.已退还保证金": "Deposit telah dikembalikan",
  "view.退费凭证": "Pengembalian Dana Voucher",
  "view.确认退还": "Konfirmasi pengembalian dana",
  "view.确认退还倒计时": "Konfirmasi hitungan mundur pengembalian dana",
  "view.报价说明文件": "Dokumen Kutipan",
  "view.用于上传盖章版报价说明文件，请在最后一次报价结束后上传": "Digunakan untuk mengunggah dokumen deskripsi kutipan versi stempel, harap mengunggahnya setelah kutipan terakhir selesai",
  "view.弃标": "abaikan tawaran",
  "view.资质审核": "Tinjauan Kualifikasi",
  "view.缴纳保证金": "Bayar setoran",
  "view.项目标书": "Tender Proyek",
  "view.投标竞价": "Penawaran penawaran",
  "view.定标": "Kalibrasi",
  "view.已过提交时间": "Waktu penyerahan telah berlalu",
  "view.请选择是否符合要求": "Silakan pilih apakah Anda memenuhi persyaratan",
  "view.请上传供应商技术文件": "Silakan unggah dokumen teknis pemasok",
  "view.请上传供应商业绩文件": "Silakan unggah dokumen kinerja pemasok",
  "view.请输入原因": "Silakan masukkan alasannya",
  "view.请在标书递交开始时间进行递交": "Silakan kirimkan dokumen penawaran pada waktu mulai",
  "view.请完善信息": "Tolong lengkapi informasinya",
  "view.操作成功": "Operasi berhasil",
  "view.保证金是否确认收到": "Apakah deposit sudah dipastikan diterima",
  "view.提示": "petunjuk",
  "view.确定": "Tentu",
  "view.取消": "Membatalkan",
  "view.是否要放弃该标": "Apakah kamu ingin membatalkan tawaran",
  "view.请上传缴费证明": "Silakan upload bukti pembayaran",
  "view.请上传营业执照资质": "Silakan unggah kualifikasi izin usaha",
  "view.请上传业绩": "Silakan unggah kinerja",
  "view.请上传代理许可": "Silakan unggah lisensi agen",
  "view.请上传": "Silakan unggah",
  "view.是否接受当前结算方式": "Menerima metode pembayaran saat ini?",
  "view.先款后货": "Bayar dulu baru diantar",
  "view.先货后款": "Pengiriman dulu, pembayaran belakangan.",
  "view.按比例支付": "Bayar secara proporsional",
  "view.项目类型": "Jenis proyek",
  "view.是否公开询价": "Apakah penyelidikannya terbuka untuk umum",
  "view.中标方式": "Cara memenangkan tawaran",
  "view.分项": "barang",
  "view.整体": "keseluruhan",
  "view.联系人/电话": "Kontak/Telepon",
  "view.询价截止时间": "Batas waktu pertanyaan",
  "view.付款条件": "Ketentuan Pembayaran",
  "view.招标名称": "Nama yang penawaran",
  "view.报名开始时间": "Waktu mulai pendaftaran",
  "view.标书费用": "Biaya tender",
  "view.招标方式": "Metode tender",
  "view.竞价保证金": "Margin penawaran",
  "view.质保期": "Masa garansi",
  "view.报名结束时间": "Waktu berakhirnya pendaftaran",
  "view.投标详情": "Bidding tawaran",
  "view.报价详情": "Deskripsi rincian",
  "view.缴费": "Pembayaran",
  "view.收起": "Letakkan itu pergi",
  "view.展开": "buka",
  "view.报价模板": "Templat Quotasi",
  "view.接受": "Terima",
  "view.不接受": "Tidak Terima",
  "view.开标倒计时": "Penghitungan Mundur Pembukaan Tawaran",
  "view.本项目开标进入倒计时阶段。请各位投标人提前做好开标相关准备，确保能准时参与开标活动。": "Pembukaan tawaran untuk proyek ini telah memasuki tahap penghitungan mundur. Semua peserta tawaran diminta untuk mempersiapkan hal-hal yang berkaitan dengan pembukaan tawaran sebelumnya untuk memastikan dapat berpartisipasi tepat waktu dalam kegiatan tersebut.",
  "view.物资报价信息": "Informasi kotasi materi",
  "view.已开标": "Tawaran terbuka",
  "view.备注": "komentar",
  "view.当前项目已开标": "Proyek saat ini telah dibuka",
  "view.投标文件": "Dokumen penawaran",
  "view.投标文件类型": "Jenis dokumen tender",
  "view.商务文件": "Dokumen bisnis",
  "view.技术文件": "Dokumen teknis",
  "view.由采购部驳回，请修改后重新提交": "Ditolak oleh Departemen Pembelian, silakan kirimkan ulang setelah diubah",
  "view.请输入招标项目/招标单位以搜索": "Silakan masukkan proyek penawaran/unit tender yang akan dicari",
  "view.项目状态": "Status proyek",
  "view.投标状态": "Status tawaran",
  "view.查询": "pertanyaan",
  "view.招标项目名称": "Nama proyek tender",
  "view.招标/询价": "Tender/Pertanyaan",
  "view.发布时间": "Waktu publikasi",
  "view.报名时间": "Waktu pendaftaran",
  "view.投标人": "Penawar",
  "view.查看": "Memeriksa",
  "view.处理": "menghadapi",
  "view.询价中/报价中": "Pertanyaan/Kutipan",
  "view.中标明细": "Tanda Detail",
  "view.中标金额": "Jumlah yang menang",
  "view.项目名称：": "Nama proyek:",
  "view.招标单位：": "Unit Tender：",
  "view.发布时间：": "Waktu rilis:",
  "view.开始日期": "tanggal mulai",
  "view.结束日期": "tanggal akhir",
  "view.重置": "Mengatur ulang",
  "view.我的关注": "Kekhawatiran saya",
  "view.详情": "Detail",
  "view.删除": "menghapus",
  "view.是否取消关注该项目": "Apakah akan berhenti mengikuti item ini",
  "view.删除成功": "Berhasil dihapus",
  "view.请输入招标项目名称以搜索": "Silakan masukkan nama proyek penawaran yang akan dicari",
  "view.请输入单位名称名称以搜索": "Silakan masukkan nama unit yang akan dicari",
  "view.项目状态：": "Status proyek:",
  "view.提交日期：": "Tanggal penyerahan:",
  "view.提交人：": "Dikirim oleh:",
  "view.我的问题": "pertanyaanku",
  "view.新增": "Baru,",
  "view.单位名称": "Nama satuan",
  "view.提交时间": "Waktu pengiriman",
  "view.提交人": "Pengarang",
  "view.提交人联系电话": "Nomor kontak penulis",
  "view.状态": "negara",
  "view.草稿": "draf",
  "view.提交未回复": "Kirim tanpa balasan",
  "view.已回复": "Membalas",
  "view.是否删除该信息?": "Apakah Anda ingin menghapus informasi ini?",
  "view.是否提交该信息?": "Apakah Anda ingin mengirimkan informasi ini?",
  "view.问题详情": "Rincian masalah",
  "view.请输入关键词": "Silakan masukkan kata kunci",
  "view.提问单位名称": "Mempertanyakan nama unit",
  "view.问题描述": "Deskripsi masalah",
  "view.提 交": "kirim",
  "view.保 存": "menyimpan",
  "view.问题回复": "Balasan pertanyaan",
  "view.问题回复情况": "Status respons pertanyaan",
  "view.问题回复人": "Respon Pertanyaan",
  "view.回复时间": "waktu balasan",
  "view.个人信息": "informasi pribadi",
  "view.姓名": "Nama",
  "view.登录账号": "Masuk akun",
  "view.纳税人识别号(身份证号)": "Nomor Pokok Wajib Pajak (Nomor Identitas)",
  "view.电子邮箱": "e-mail",
  "view.保存": "menyimpan",
  "view.保存成功": "Simpan berhasil",
  "view.个人中心": "Pusat Pribadi",
  "view.我的投标": "Tawaran Saya",
  "view.密码修改": "Perubahan kata sandi",
  "view.处理事项": "Menangani Urusan",
  "view.旧密码": "Kata Sandi Lama",
  "view.新密码": "Kata Sandi Baru",
  "view.确认密码": "Konfirmasi Kata Sandi",
  "view.密码不一致": "Kata sandi tidak konsisten",
  "view.修改成功": "Modifikasi berhasil",
  "view.是否提交投标文件": "Apakah akan menyerahkan dokumen penawaran",
  "view.支付比例": "rasio pembayaran",
  "view.本轮报价": "Kutipan babak ini",
  "view.下载模板": "Unduh templat",
  "view.导入": "Impor",
  "view.每轮次单价降价幅度比上一轮单价低": "Penurunan harga satuan pada setiap putaran lebih rendah dibandingkan harga satuan pada putaran sebelumnya",
  "view.元": "Yuan",
  "view.预付款": "pembayaran di muka",
  "view.发货款": "pembayaran pengiriman",
  "view.到货款": "Pembayaran pada saat kedatangan",
  "view.到货检验款": "Pembayaran pemeriksaan kedatangan",
  "view.设备安装费": "Biaya pemasangan peralatan",
  "view.项目检验费用": "Biaya inspeksi proyek",
  "view.质保": "Jaminan",
  "view.单价": "harga satuan",
  "view.请完善": "Tolong tingkatkan",
  "view.信息": "informasi",
  "view.导入中": "Pengimporan",
  "view.导入成功": "Impor berhasil",
  "view.操作失败": "Operasi gagal",
  "view.询价单位": "Unit Penyelidikan",
  "view.商务联系人/电话": "Kontak/telepon bisnis",
  "view.分项中标": "Tawaran pemenang sub-item",
  "view.整体中标": "Tawaran yang menang secara keseluruhan",
  "view.投标方式": "Metode penawaran",
  "view.现场招标": "Penawaran di tempat",
  "view.线上招标": "Tender Online",
  "view.技术联系人/电话": "Kontak/telepon teknis",
  "view.开标时间": "Waktu pembukaan tawaran",
  "view.整体排名：当前排名第": "Rangkaian umum: saat ini ditangkap sebagai",
  "view.财务成本价": "Harga biaya keuangan",
  "view.当前最低价": " Harga terendah saat ini",
  "view.当前最高价": " Harga tertinggi saat ini",
  "view.距离报价结束：": "Time remaining until quotation ends:",
  "view.上一轮": "Previous round",
  "view.每轮次报价降价幅度比上一轮报价低": "Penurunan harga setiap putaran harus lebih rendah daripada harga putaran sebelumnya.",
  "view.每轮次报价上涨幅度比上一轮报价高": "Kenaikan harga setiap putaran harus lebih tinggi daripada harga putaran sebelumnya.",
  "view.每轮次报价降价幅度比全场最低价低": "Penurunan harga setiap putaran harus lebih rendah daripada harga terendah di seluruh lelang.",
  "view.每轮次报价上涨幅度比全场最高价高": "Kenaikan harga setiap putaran harus lebih tinggi daripada harga tertinggi di seluruh lelang.",
  "view.技术附件": "Lampiran Teknis",
  "view.项目总预算：": "Total Anggaran Proyek:",
  "view.预算总价": "Total Harga Anggaran",
  "view.预算单价": "Harga Satuan Anggaran",
  "view.是否含税": "Termasuk pajak",
  "view.标段信息": "Informasi paket",
  "view.报价（含税）": "Penawaran (termasuk pajak)",
  "view.系数": "Koefisien",
  "view.总价（含税）": "Harga total (termasuk pajak)",
  "view.请确认": "Silakan konfirmasi",
  "view.真实报价是否为0，若不对该标的物进行报价，则空置不填": "Apakah penawaran sebenarnya 0, kosong tidak diisi jika tidak ada penawaran untuk subjek",
  "view.标段": "Paket",
  "view.数量": "Kuantitas",
  "view.报价方式": "Metode penawaran",
  "view.限价": "Batas harga",
  "view.系数名称": "Nama koefisien",
  "view.币种单位": "Unit mata uang",
  "view.询价要求文件": "Dokumen permintaan pertanyaan",
  "view.标的物附件：": "Lampiran materi pelajaran:",
  "view.已关注": "Sudah diikuti",
  "view.关注": "fokus pada",
  "view.参与询价": "Berpartisipasi dalam penyelidikan",
  "view.报名成功": "Pendaftaran berhasil",
  "view.关注成功": "Fokus pada kesuksesan",
  "view.无": "Tidak ada",
  "view.期望到货日期": "Tanggal Kedatangan yang Diharapkan",
  "view.标段名称": "Nama Bagian Tender",
  "view.取消关注成功": "Menghapus perhatian pada keberhasilan",
  "view.建设单位": "Unit Pembangunan",
  "view.收费信息": "Informasi pengisian daya",
  "view.金额": "jumlah",
  "view.账号": "akun",
  "view.投标人资质要求": "Persyaratan kualifikasi untuk penawar",
  "view.报名": "Mendaftar",
  "view.返回首页": "Kembali ke beranda situs",
  "view.密码重置": "Setel ulang kata sandi",
  "view.进行身份验证": "Lakukan otentikasi",
  "view.重新设置密码": "Setel ulang kata sandi",
  "view.完成密码重置": "Selesaikan pengaturan ulang kata sandi",
  "view.邮箱地址": "alamat email",
  "view.图形验证": "Verifikasi grafis",
  "view.请计算得出验证码结果": "Silakan hitung hasil kode verifikasinya",
  "view.邮箱验证": "Verifikasi email",
  "view.请输入邮箱收到的验证码": "Silakan masukkan kode verifikasi yang diterima melalui email",
  "view.重置密码": "Setel ulang kata sandi",
  "view.请输入再次输入新密码": "Silakan masukkan kembali kata sandi baru",
  "view.修改": "Merevisi",
  "view.密码重置成功": "Reset kata sandi berhasil",
  "view.您的密码已重置成功，请牢记新密码！": "Kata sandi Anda telah berhasil direset, harap ingat kata sandi baru! ",
  "view.已有账号？": "Sudah punya akun? ",
  "view.去登录": "Masuk",
  "view.两次输入的密码不一致": "Kata sandi yang dimasukkan dua kali tidak konsisten",
  "view.邮箱格式有误": "Format email salah",
  "view.手机号码不能为空": "Nomor ponsel tidak boleh kosong",
  "view.请输入正确的手机号码": "Silakan masukkan nomor ponsel yang benar",
  "view.密码强度不够(数字、大小写、特殊字符组成)": "Kata sandi tidak cukup kuat (terdiri dari angka, huruf besar dan kecil, karakter khusus)",
  "view.获取验证码": "Dapatkan kode verifikasi",
  "view.请选择": "Silakan pilih",
  "view.请输入您的密码": "Silakan masukkan kata sandi Anda",
  "view.用户密码长度必须介于 5 和 20 之间": "Panjang kata sandi pengguna harus antara 5 dan 20",
  "view.短信验证": "Verifikasi SMS",
  "view.手机号码": "Nomor Telepon",
  "view.请输入短信收到的验证码": "Masukkan kode verifikasi yang diterima melalui SMS",
  "view.招询公告": "Pengumuman Permintaan",
  "view.招标项目": "Proyek tender",
  "view.更多": "Lagi",
  "view.预计金额：": "Perkiraan jumlah:",
  "view.询价项目": "Barang pertanyaan",
  "view.欢迎注册信翼通招标网": "Selamat datang untuk mendaftar di Jaringan Penawaran Xinyitong",
  "view.单位注册": "Pendaftaran unit",
  "view.个人注册": "Pendaftaran pribadi",
  "view.企业名称": "Nama perusahaan",
  "view.密码": "kata sandi",
  "view.身份证": "Kartu identitas",
  "view.邮箱": "Surat",
  "view.邮箱验证码": "Kode verifikasi email",
  "view.主营业务": "Bisnis utama",
  "view.为了更精确投标业务，请填写主营业务": "Agar menawar bisnis lebih akurat, silakan isi bisnis utama",
  "view.我已阅读并同意": "Saya telah membaca dan menyetujui",
  "view.《招标网平台会员注册须知》": "\"Petunjuk Pendaftaran Keanggotaan Platform Jaringan Penawaran\"",
  "view.《招标网平台法律声明》": "\"Pernyataan Hukum Platform Jaringan Penawaran\"",
  "view.手机号格式有误": "Format nomor ponsel salah",
  "view.请勾选注册须知": "Silakan periksa instruksi pendaftaran",
  "view.填写企业信息": "Isi informasi perusahaan",
  "view.信息审核中": "Informasi sedang diverifikasi",
  "view.身份认证通过": "Verifikasi identitas telah lulus",
  "view.公司信息": "Informasi perusahaan",
  "view.供应商名称": "Nama pemasok",
  "view.供应商简称": "Singkatan nama pemasok",
  "view.供应商地址": "Alamat pemasok",
  "view.供应商类别": "Kategori pemasok",
  "view.企业类型": "Jenis perusahaan",
  "view.生产地址": "Alamat produksi",
  "view.生产规模/产能（台套）": "Skala produksi/kapasitas produksi (unit)",
  "view.代理商资质": "Kualifikasi agen",
  "view.产品生产资质": "Kualifikasi produksi produk",
  "view.纳税性质": "Jenis pajak",
  "view.实缴资本": "Modal disetor",
  "view.注册地址": "Alamat pendaftaran",
  "view.注册资金": "Modal pendirian",
  "view.职工人数": "Jumlah karyawan",
  "view.厂房面积": "Luas pabrik",
  "view.年营业额": "Omset tahunan",
  "view.公司成立日期": "Tanggal pendirian perusahaan",
  "view.三年财报": "Laporan keuangan tiga tahun",
  "view.经营范围": "Lingkup bisnis",
  "view.供应产品名称(产品类别、主营产品)": "Nama produk yang disediakan (kategori produk, produk utama)",
  "view.产品出厂检测标准": "Standar pemeriksaan produk sebelum keluar pabrik",
  "view.是否经我司试用": "Apakah telah dicoba oleh perusahaan kami",
  "view.营业信息": "Informasi bisnis",
  "view.法定代表人": "Wakil hukum",
  "view.法人代表身份证明": "Kartu identitas wakil hukum",
  "view.下载样例": "Unduh contoh",
  "view.至": "hingga",
  "view.点击上传": "Klik untuk unggah",
  "view.文件地址不存在": "Alamat berkas tidak ditemukan",
  "view.该格式不支持在线预览，已下载文件": "Format ini tidak mendukung pratinjau online, berkas telah diunduh.",
  "view.投标人信息": "Informasi penawar",
  "view.联系方式": "Informasi kontak",
  "view.委托书有效期 ": "Masa berlaku surat kuasa",
  "view.开户信息": "Informasi pembukaan rekening",
  "view.银行账号": "Nomor rekening bank",
  "view.开户银行": "Nama bank",
  "view.是否进行企业认证": "Apakah akan melakukan sertifikasi perusahaan",
  "view.护照": "pasport",
  "view.法人代表身份证明（正面）": "Kartu Identitas Perwakilan Hukum (Sisi Depan)",
  "view.法人代表身份证明（反面）": "Kartu Identitas Perwakilan Hukum (Sisi Belakang)",
  "view.大于当前系统时间": "Lebih besar dari waktu sistem saat ini",
  "view.开始时间不得大于结束时间": "Waktu awal tidak dapat melebihi waktu akhir",
  "view.填写个人信息": "Isi informasi pribadi",
  "view.下一步": "Langkah selanjutnya",
  "view.上一步": "Langkah sebelumnya",
  "view.信息反馈": "Umpan balik informasi",
  "view.请在企业信息内完善法人身份证信息": "Silakan lengkap informasi kartu identitas wakil hukum dalam informasi perusahaan",
  "view.开户行号": "Kode Bank",
  "view.供货类型及品牌": "Jenis Pasokan dan Merek",
  "view.添加": "Tambah",
  "view.供货类型": "Jenis Pasokan",
  "view.品牌": "Merek",
  "view.业务联系人": "Kontak Bisnis",
  "view.人员类型": "Jenis Personel",
  "view.请选择人员类型": "Silakan pilih jenis personel",
  "view.请添加业务联系人": "Silakan tambahkan kontak bisnis",
  "view.电话": "Telepon",
  "view.单位管理人": "Administrator Perusahaan",
  "view.合同签订人": "Penandatangan Kontrak",
  "view.采购业务员": "Petugas Pengadaan",
  "view.请添加供货类型及品牌信息": "Silakan tambahkan informasi jenis pasokan dan merek",
  "view.招标联系人": "Kontak Lelang",
  "view.选择人员": "Pilih Personil",
  "view.选择招标联系人": "Pilih Kontak Lelang",
  "view.正常": "Normal",
  "view.停用": "Nonaktif",
  "view.上传失败": "Upload gagal",
  "view.审批驳回": "Persetujuan Ditolak",
  "view.审批中": "Dalam Proses Persetujuan",
  "view.审核通过": "Disetujui",
  "view.物资编码": "Kode Material",
  "view.来源": "Sumber",
  "view.合同名称/招标项目": "Nama Kontrak/Proyek Tender",
  "view.商品信息": "Informasi Produk",
  "view.采购/招标负责人": "Orang Bertanggung Jawab Pengadaan/Tender",
  "view.驳回原因": "Alasan Penolakan",
  "view.完善信息": "Perbaiki Informasi",
  "view.物资名称-信息填写": "Nama Material - Pengisian Informasi",
  "view.是否进口": "Diimpor atau Tidak",
  "view.商品介绍": "Pengenalan Produk",
  "view.商品主图(包含图片、3D建模、视频等)": "Gambar Utama Produk(Termasuk gambar, pemodelan 3D, video, dll.)",
  "view.批量提交": "Kirimkan Batch",
  "view.请选择要提交的数据": "Silakan Pilih Data untuk Dikirimkan",
  "view.物资名称-信息查看": "Nama Material - Menampilkan Informasi",
  "view.查看信息": "Lihat Informasi",
  "view.模板.xlsx": "template.xlsx",
  "view.业绩文件": "Dokumen Kinerja",
  "view.代理许可": "Lisensi Agen",
  "view.报价文件": "Dokumen Penawaran",
  "view.投标项目": "Proyek penawaran",
  "view.驳回信息": "Menolak informasi",
  "view.信息审核驳回": "Audit informasi ditolak",
  "view.物资/项目": "Bahan / Proyek",
  "view.企业类别": "Kategori Perusahaan",
  "view.国内供应商": "Pemasok Dalam Negeri",
  "view.印尼供应商": "Pemasok Indonesia",
  "view.转为印尼供应商": "Ubah Menjadi Pemasok Indonesia",
  "view.转为国内供应商": "Ubah Menjadi Pemasok Dalam Negeri",
  "view.企业信息": "Informasi perusahaan",
  "view.是否转为国内供应商": "Apakah akan diubah menjadi pemasok domestik",
  "view.备件信息完善": "Penyempurnaan Informasi Spare Part",
  "view.招标项目/招标单位": "Proyek Tender / Unit Penyelenggara Tender",
  "view.招标负责人": "Penanggung Jawab Tender",
  "view.备件信息完善详情": "Rincian Penyempurnaan Informasi Spare Part",
  "view.物资信息": "Informasi Material",
  "view.备件信息": "Informasi Spare Part",
  "view.备件名称": "Nama Spare Part",
  "view.更换周期": "Siklus Penggantian",
  "view.主图": "Gambar Utama",
  "view.请添加备件信息": "Silakan Tambahkan Informasi Spare Part",
  "view.投标授权委托书过期提醒": "Pengingat Kadaluarsa Surat Kuasa Penawaran",
  "view.注：距离投标授权委托书过期还有": "Catatan: Sisa waktu hingga Surat Kuasa Penawaran kadaluarsa",
  "view.天": "hari",
  "view.请尽快重新上传": "Harap unggah ulang secepatnya ",
  "view.投标授权委托书已过期，请尽快重新上传": "Surat Kuasa Penawaran telah kadaluarsa, harap unggah ulang secepatnya",
  "view.授权委托书管理": "Pengelolaan Surat Kuasa",
  "view.审批通过时间": "Waktu Persetujuan Disetujui",
  "view.变更授权委托书": "Ubah Surat Kuasa",
  "view.授权委托书已上传，目前正在审核中，请耐心等待": "Surat kuasa telah diunggah dan sedang dalam proses pemeriksaan, mohon menunggu dengan sabar.",
  "view.请输入本人真实姓名": "Silakan masukkan nama asli Anda",
  "view.您的问题已提交，运营人员将会与您联系": "Pertanyaan Anda telah dikirim, staf operasional akan menghubungi Anda",
  "view.返回": "kembali",
  "view.变更供货类型": "Ubah Jenis Penyediaan Barang",
  "view.项目信息": "Informasi Proyek",
  "view.变更申请记录": "Catatan Permintaan Perubahan",
  "view.项目名称": "Nama Proyek",
  "view.提交日期": "Tanggal Pengajuan",
  "view.处理人": "Penanggung Jawab Pengolahan",
  "view.处理时间": "Waktu Pengolahan",
  "view.贵单位供货类型信息与当前项目物资分类": "Informasi Jenis Pasokan dan Klasifikasi Barang Saat Ini",
  "view.不符，请确认是否符合招标要求并继续报名。": "Terdapat ketidaksesuaian. Silakan konfirmasi apakah memenuhi persyaratan tender sebelum melanjutkan pendaftaran.",
  "view.检测到贵企业有正在审批的企业信息变更申请，请等待变更流程审批完成、企业信息更新生效后，再重新提交报名。": "Ditemukan bahwa perusahaan Anda sedang mengajukan perubahan informasi perusahaan yang sedang dalam proses persetujuan. Harap tunggu hingga proses perubahan selesai dan informasi perusahaan diperbarui sebelum mengajukan pendaftaran kembali.",
  "view.物料编码": "Kode Bahan",
  "view.价格类型":'Jenis harga',
  "view.报名状态":'Status pendaftaran',
  "view.待完善价格":'Harga yang sempurna',
  "view.待审核":'Untuk diaudit',
  "view.报名失败":'Pendaftaran Gagal',
  "view.价格审批驳回":'Penolakan persetujuan harga',
  "view.价格审批中":'Harga sedang disetujui',

}